'use strict';
import {FORM_REQUIREMENT_COLLECTION} from '../config';


export function FormRequirementDomainProvider() {
  return {
    $get: [
      'AbstractDomainClass',
      '$$AbstractRequirement',
      function (
        AbstractDomainClass,
        $$AbstractRequirement,
      ) {
        //console.log('Calling FormRequirementDomain');
        function FormRequirementDomain(data) {
          AbstractDomainClass.call(this, FormRequirementDomain, data);
        }

        $$AbstractRequirement.__inheritFrom(FormRequirementDomain, 'FormRequirementDomain', FORM_REQUIREMENT_COLLECTION);

        FormRequirementDomain.$constraints.addConstraints({
          task: {type: 'Domain', domainClass: 'TaskDomain'},

          form: {type: 'Domain', domainClass: 'FormDomain'},
          formVersion: {type: 'string'},
          formResponse: {type: 'string', domainClass: 'FormResponseDomain', nullable: true, simpleLink: true},

          assetFormRequirements: {
            type: 'DomainCollection',
            domainClass: 'AssetFormRequirementDomain',
            link: 'requirement',
            belongsTo: true,
          },
        });

        return FormRequirementDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/forms/FormRequirementDomain.js